import { useSuspenseQuery } from '@tanstack/react-query'

import { isPermissionDenied } from '@shared/twilio/src/utils'

export default function useMicPermissions() {
  const { data: error } = useSuspenseQuery({
    queryKey: ['mic-permission'],
    queryFn: async () => {
      try {
        await checkDeniedPermissions()
        await checkUserMediaPermissions()
        return null
      } catch (e) {
        return e
      }
    },
    staleTime: Infinity,
    retry: false,
    persister: undefined,
  })

  return { error, isError: error !== null }
}

const checkDeniedPermissions = async () => {
  const isMicrophonePermissionDenied = await isPermissionDenied('microphone')

  if (isMicrophonePermissionDenied) {
    throw new Error('MicrophonePermissionsDenied')
  }
}

export const checkUserMediaPermissions = async () => {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true })

  // Stop immediately to avoid the camera light turning on.
  stream.getTracks().forEach((track) => track.stop())
}
